import { selectDeletingPaymentMethod, selectSelectedPaymentMethod } from '../../../../../store/workspace/selectors';
import { deletePaymentMethodThunk } from '../../../../../store/workspace/thunks';
import { setDeleteCardModal } from '../../../../../store/workspace/slice';
import { useDispatch, useSelector } from '../../../../../store/store';
import { RemoveCreditCardIcon } from '../../../../../assets/icons';
import Button from '../../../../../components/Button';
import Modal from '../../../../../components/Modal';
import styles from './style.module.scss';

export default function DeleteCard() {
    const dispatch = useDispatch();
    const isLoading = useSelector(selectDeletingPaymentMethod);
    const selectedPaymentMethod = useSelector(selectSelectedPaymentMethod);

    const confirm = () => {
        if (!selectedPaymentMethod) return;

        dispatch(deletePaymentMethodThunk({
            action: 'delete_payment_method',
            pmId: selectedPaymentMethod.id
        }));
    };

    return (
        <Modal
            size='sm'
            title='Delete card'
            icon={<RemoveCreditCardIcon />}
            childClassName={styles.wrapper}
            closeFunc={() => dispatch(setDeleteCardModal(false))}
        >
            <p>
                Are you sure you want to delete Visa Card
                ending in **** {selectedPaymentMethod?.card.last4}?
            </p>
            <div className={styles.actions}>
                <Button
                    text='Cancel'
                    type='Outline-Primary'
                    className={styles.actions_btn}
                    onClick={() => dispatch(setDeleteCardModal(false))}
                />
                <Button
                    type='Error'
                    text='Delete'
                    onClick={confirm}
                    loading={isLoading}
                    className={styles.actions_btn}
                />
            </div>
        </Modal>
    )
};
